<template>
<div class="group-panel">

    <div class="group-heading" :class="{collapsed: collapsed}" @click="toggleCollapse">
        <div class="group-heading-label">
            <v-icon style="margin-top:-3px" class="collapse-button" :class="{collapsed:collapsed}" small >mdi-chevron-up</v-icon>
            &nbsp;{{schema.label}}
            <div v-if="summary && collapsed" class="summary-text"> ({{summary}})</div>
        </div>
    </div>

    <v-expand-transition>
        <div v-if="schema && !collapsed" style="border-top:solid 1px #ddd" class="expanded-area">
            <div v-if="!schema.fields" style="display:flex">
                <div v-for="(columnSchema, csIndex) in schema.columns" class="form-block" :key="csIndex">
                    <FormBlock
                        :horizontal="schema.horizontal"
                        :schema="columnSchema" 
                        :value="value"
                        :context="context"
                        @change="emitChanges"
                    />
                </div>
            </div>
            <div v-if="schema.fields" class="form-block">
                <FormBlock
                    :horizontal="schema.horizontal"
                    :schema="modifiedSchema" 
                    :value="value"
                    :context="context"
                    @change="emitChanges"

                />
                    <!-- @change="$emit('change', $event)" -->
            </div>
        </div>
    </v-expand-transition>
</div>

</template>

<script>
import ConfirmIcon from '@/ui-elements/ConfirmIcon'
import AlertHelpers from '../../helpers/AlertHelpers'
import draggable from 'vuedraggable'
import Merger from '../Merger'

export default {
    data() {
        return {
            collapsed: false,
        }
    },

    components: {
        ConfirmIcon, draggable
    },
    
    props: {
        schema: Object,
        value: {
            type: Object,
            default: function() {
                return {}
            },
        } ,
        context: Object,
    },

    computed: {
        modifiedSchema() {
            const schema = Object.assign({}, this.schema)
            schema.type = ''
            return schema
        }, 
        columnStyle() {
            const style = {}
            if(this.schema.columns) {
                style['min-width'] = '100px';
                style['flex-basis'] = this.schema.width || '150px'
            }
            return style
        },

        schemaFields() {
            this.schema.fields.forEach(field => {
                field._root = this.schema._root
            })
            return this.schema.fields
        },

        readOnly() {
            return Boolean(this.schema._root.readOnly)
        },

        itemCount() {
            if(this.value)
                return this.value.length
            else
                return 0
        },

        summary() {
            if(!this.schema.summary)
                return ''

            if(this.schema.summary && this.schema.summary == '[$true_labels]')
                return Merger.trueLabels(this.schema.fields, this.value)
            else
                return Merger.processExpressions(this.schema.summary, this.value)
        },        
   
    },

    methods: {

        calculatePaymentTotals() {
            let currencyTotal = 0
            this.schema.fields.forEach(field => {
                if(field.type == 'Currency' || field.inputType == 'Currency') {
                    const v1 = this.value[field.name]
                    currencyTotal += v1 || 0
                }
            })
            // if(currencyTotal) {
                this.$set(this.value, this.schema.name + '_total_currency', currencyTotal)
            // }
        },
       
        emitChanges(newVal) {  
            console.log('Section emitting changes', newVal)
            this.calculatePaymentTotals()
            this.$emit('change', newVal)
        },
        toggleCollapse() {
            this.collapsed = !this.collapsed
        },
    },

    created() {

    }
}
</script>

<style scoped>  

.group-panel {
    border: solid 1px #ddd;
    border-radius:5px;
    margin-bottom:10px;
    background-color:rgba(0,0,0,0.02);
}

.group-heading {
    color: #666;
    background-color:rgba(0,0,0,0.02);   
    position: relative;
    overflow: hidden;
    border-radius: 5px 5px 0 0; 
    user-select: none;
}

.group-heading.collapsed {
    border-radius: 5px 5px 5px 5px; 
}

.group-heading-label {
    display:inline-block;
    padding:  8px 10px;
}

.group-heading-buttons {
    text-align:right;
    position:absolute;
    right:0;
    display:inline-flex;
    transition: right .3s ease-in-out;
}

.group-heading-buttons.collapsed {
    right:-100px;
}

.group-heading-button {
    padding:8px 16px;
    display: inline-block;
    border-left: solid 1px #ddd;
}

.group-heading-button:hover, .group-heading:hover {
    background-color: rgba(0,0,0,0.03);
}

.group-item-area {
    position:relative;
    padding: 22px 20px 20px 20px; 
    border-top: solid 1px #ddd;
}

.group-item-area.read-only {
    position:relative;
    padding: 10px 10px 0px 10px;
}

.group-item-area.columns {
    padding: 10px 20px 10px 10px; 
}

.columns {
    display:flex;flex-wrap:wrap;
}
.columns > .group-item-area {
    flex-grow: 1;
    flex-shrink: 1;
}

.form-block {
    padding:20px;
}


.collapse-button {
    transition: transform .5s ease-in-out;
}
.collapse-button.collapsed {
    transform: rotate(180deg);
}

.summary-text {
    font-size:14px;
    font-weight:200;
}

@supports (-webkit-touch-callout: none) {
    .group-item-area {
        padding-bottom: 0px!important;
    }
    .group-item-area.columns {
        padding-bottom: 0px!important;
    }

    .form-block {
        padding-bottom:0px!important;
    }
}

   
</style>



// WEBPACK FOOTER //
// SectionControl.vue?77ebcc58